const Z_INDEX_VALUES = Object.freeze({
  POPPER: 1400,
  FAB: 1401,
  MOBILE_MENU: 1401,
  OVERLAY: 1300,
});

export default Z_INDEX_VALUES;
